import React, { useState, useEffect } from 'react';
import {
  Label,
} from 'reactstrap';
import { DatetimePicker } from '../../../commons/controls';
// import { DateTimePicker } from 'react-widgets'
import Services from '../services';
import _ from 'lodash';
import SwichButton from '../../../commons/SwitchButton';
import RFField from '../../../components/Form/RFField';
import SelectField from '../../../components/Form/SelectField'
import moment from 'moment';

const ROW_STYLE = { marginBottom: '15px' };

let selected = false;

const KedvezmenyForm = props => {
  const {
    modositas,
    formAzonosito,
    formNev,
    formKedvezmenyTipus,
    formFunkciok,
    formTipus,
    formErvenyesules,
    formMertekTipus,
    formMertek,
    formKezdete,
    formVege,
    formCiklusMennyiseg,
    formCiklusEgyseg,
    formKartyaTipusok,
    formAlanya,
    formAlanyai,
    toggleMertekTipus,
    handleInputChange,
    handleSelectInputChange,
    handleDateInputChange,
    emptyKedvezmenyAlanyai
  } = props;

  const loadTipusOptions = (input, callback) => {
    Services.listKedvezmenyTipusEnum((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(t => t.caption.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadCiklusEgysegOptions = (input, callback) => {
    Services.listCiklusEgysegEnum((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(f => f.caption.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadKedvezmenyTipusOptions = (input, callback) => {
    Services.listKedvezmenyTipus((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(t => t.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadFunkcioOptions = (input, callback) => {
    Services.listFunkcio(input, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(f => f.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadKartyaTipusOptions = (input, callback) => {
    Services.listKartyaTipus(false, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(kt => kt.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadAlanyOptions = (input, callback) => {
    Services.listKedvezmenyAlanya((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(a => a.caption.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadAlanyaiOptions = (input, callback) => {
    if (formAlanya)
      switch (formAlanya.name) {
        case 'SZEMELY':
          Services.listDolgozo(null, (err, res) => {
            if (!err) {
              let options = [];
              res[0].list.filter(d => d.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
                options.push(item);
              });
              callback(options);
            }
          });
          break;
        case 'JEGY':
          Services.listJegy(null, (err, res) => {
            if (!err) {
              let options = [];
              res[0].filter(j => j.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
                options.push(item);
              });
              callback(options);
            }
          });
          break;
      }
  }

  const handleDateChange = (e,v,type) => {
    if(selected) {
      selected = false;
      switch (type) {
        case 'formKezdete':
          if (v) {
            v = moment(v).startOf('day');
          }
          handleDateInputChange(e, v, "formKezdete");
          break;
        case 'formVege':
          if (v) {
            v = moment(v).endOf('day');
          }
          handleDateInputChange(e, v, "formVege");
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'formKezdete':
          handleDateInputChange(e, v == '' ? v : new Date(e), "formKezdete");
          break;
        case 'formVege':
          handleDateInputChange(e, v == '' ? v : new Date(e), "formVege");
          break;
        default:
          break;
      }
    }
  }

  const renderForm = () => {
    return (
      <>
        <div className="row">
          <div className="col-md-12" style={{ paddingRight: '2px' }}>
            <h5>Kedvezmény alapadatok</h5>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <RFField
              label="Kedvezmény azonosító: *"
              name="formAzonosito"
              disabled={modositas}
              value={formAzonosito}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="col-md-3">
            <RFField
              label="Kedvezmény megnevezése: *"
              name={"formNev"}
              value={formNev}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="col-md-3">
            <SelectField
              label='Kedvezmény kategória: *'
              variant='async'
              name="formKedvezmenyTipus"
              id="formKedvezmenyTipus"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, 'formKedvezmenyTipus')}
              loadOptions={_.debounce(loadKedvezmenyTipusOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={formKedvezmenyTipus}
              isClearable
              defaultOptions
            />
          </div>
          <div className="col-md-3">
            <SelectField
              variant='async'
              label='Funkciók:'
              name="formFunkciok"
              id="formFunkciok"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, 'formFunkciok')}
              loadOptions={_.debounce(loadFunkcioOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={formFunkciok}
              isMulti
              isClearable
              defaultOptions
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12" style={{ paddingRight: '2px' }}>
            <h5>Kedvezmény feltételei</h5>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4" style={{ paddingRight: '2px' }}>
            <SelectField
              variant='async'
              label='Típus:'
              name="formTipus"
              id="formTipus"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, 'formTipus')}
              loadOptions={_.debounce(loadTipusOptions, 1000)}
              getOptionLabel={option => option.caption}
              getOptionValue={option => option.name}
              value={formTipus}
              isClearable
              defaultOptions
            />
          </div>
          <div className="col-md-4">
            <RFField
              label="Felhasználási korlát: "
              name={"formErvenyesules"}
              placeholder="KORLÁTLAN"
              value={formErvenyesules}
              onChange={handleInputChange}
              regex={["^[0-9]*$", 'Érvénytelen szám érték!']}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <Label for={"formMertek"}>Kedvezmény mértéke: *</Label>
            <SwichButton
              active={formMertekTipus}
              trueLabel="%"
              trueToggle={toggleMertekTipus}
              trueWidth={100}
              falseToggle={toggleMertekTipus}
              falseLabel="Összeg"
              falseWidth={100}
            //style={{ marginTop: 29 }}
            />
          </div>
          <div className="col-md-5" style={{ marginTop: 28 }}>
            <RFField
              name={"formMertek"}
              value={formMertek}
              onChange={handleInputChange}
              regex={["^[0-9]*$", 'Érvénytelen szám érték']}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-5">
            <DatetimePicker
              label={'Érvényesség kezdete: *'}
              id="formKezdete"
              name="formKezdete"
              containerClassName="organw-date-time"
              time
              format="YYYY-MM-DD HH:mm:ss"
              messages={{ dateButton: "dátum", timeButton: "idő" }}
              value={formKezdete && new Date(formKezdete)}
              onChange={(e, v) => handleDateChange(e, v, 'formKezdete')}
              onSelect={() => { selected = true }}
              timePrecision="seconds"
            />
          </div>
          <div className="col-md-5">
            <DatetimePicker
              label={'Érvényesség vége: '}
              id="formVege"
              name="formVege"
              containerClassName="organw-date-time"
              time
              format="YYYY-MM-DD HH:mm:ss"
              messages={{ dateButton: "dátum", timeButton: "idő" }}
              value={formVege && new Date(formVege)}
              onChange={(e, v) => handleDateChange(e, v, 'formVege')}
              onSelect={() => { selected = true }}
              timePrecision="seconds"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-5">
            <RFField
              label="Ciklus mennyiség:"
              name={"formCiklusMennyiseg"}
              onChange={handleInputChange}
              value={formCiklusMennyiseg}
            />
          </div>
          <div className="col-md-5">
            <SelectField
              variant='async'
              label={'Ciklus mennyiségi egység: '}
              name="formCiklusEgyseg"
              id="formCiklusEgyseg"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, 'formCiklusEgyseg')}
              loadOptions={_.debounce(loadCiklusEgysegOptions, 1000)}
              getOptionLabel={option => option.caption}
              getOptionValue={option => option.name}
              value={formCiklusEgyseg}
              isClearable
              defaultOptions
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-5" style={{ paddingRight: '2px' }}>
            <SelectField
              variant='async'
              label='Kapcsolódó vásárlói kártyatípusok:'
              name="formKartyaTipusok"
              id="formKartyaTipusok"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, 'formKartyaTipusok')}
              loadOptions={_.debounce(loadKartyaTipusOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={formKartyaTipusok}
              isMulti
              isClearable
              defaultOptions
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12" style={{ paddingRight: '2px', marginTop: 12 }}>
            <h5>Kedvezmény alanya</h5>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <SelectField
              variant='async'
              label='Kedvezmény alanya: *'
              name="formAlanya"
              id="formAlanya"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => {
                handleSelectInputChange(v, 'formAlanya');
                emptyKedvezmenyAlanyai();
              }}
              loadOptions={_.debounce(loadAlanyOptions, 1000)}
              getOptionLabel={option => option.caption}
              getOptionValue={option => option.name}
              value={formAlanya}
              isClearable
              defaultOptions
            />
          </div>
          {formAlanya &&
            <div className="col-md-8">
              <SelectField
                variant='async'
                label={formAlanya.caption + ': '}
                name="formAlanyai"
                id="formAlanyai"
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={v => handleSelectInputChange(v, 'formAlanyai')}
                loadOptions={_.debounce(loadAlanyaiOptions, 1000)}
                getOptionLabel={option => option.nev + " (" + option.azonosito + ")"}
                getOptionValue={option => option.id}
                value={formAlanyai}
                closeMenuOnSelect={false}
                isMulti
                isClearable
              />
            </div>
          }
        </div>
      </>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12">
        {renderForm()}
      </div>
    </div>
  );
}

export default KedvezmenyForm;